<template>
	<el-tabs type="border-card" class="h-100 no-scroll" @tab-click="handleClick">
		<el-tab-pane class="mt-3" v-for="(menu, index) in tabMenuList" :key="index" :label="menu.name">
			<component :is="menu.tag" class="px-3 pb-2" :scrId="scrId" :tab1="tab1" :tab2="tab2" :tab3="tab3"></component>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcmRegn/store/helpers';
import PcPcmRegnTap1 from './PcPcmRegnTap1/PcPcmRegnTap1.vue';
import PcPcmRegnTap2 from './PcPcmRegnTap2/PcPcmRegnTap2.vue';
import PcPcmRegnTap3 from './PcPcmRegnTap3/PcPcmRegnTap3.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		tab1: { type: String, default: '' },
		tab2: { type: String, default: '' },
		tab3: { type: String, default: '' }
	},
	data() {
		return {
			tabMenuList: [
				{ tag: 'pc-pcm-regn-tap-1', name: this.tab1 },
				{ tag: 'pc-pcm-regn-tap-2', name: this.tab2 },
				{ tag: 'pc-pcm-regn-tap-3', name: this.tab3 }
			]
		};
	},
	components: { PcPcmRegnTap1, PcPcmRegnTap2, PcPcmRegnTap3 },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		handleClick(tab) {
			if (tab.index === '0') {
				this.setState_({ key: 'isLoading1', value: true });
			} else if (tab.index === '1') {
				this.setState_({ key: 'isLoading2', value: true });
			} else if (tab.index === '2') {
				this.setState_({ key: 'isLoading3', value: true });
			}
		}
	}
};
</script>
